import React from "react";

import { PublicationStatus } from "src/types/publication";
import IDHFormattedMessage from "../../IDHFormattedMessage/IDHFormattedMessage";

export const publicationStatusesWithTooltip = [
  PublicationStatus.Fresh,
  PublicationStatus.Error,
  PublicationStatus.NotFound,
  PublicationStatus.HiddenLikesEnabled,
  PublicationStatus.RestrictedByAge,
  PublicationStatus.StatsUnavailable,
];

export const publicationStatusesWithWarning = [
  PublicationStatus.Error,
  PublicationStatus.NotFound,
  PublicationStatus.HiddenLikesEnabled,
  PublicationStatus.RestrictedByAge,
  PublicationStatus.StatsUnavailable,
];

export const getPublicationStatusNameBasedOnStatus = (
  status: PublicationStatus,
): string => {
  if (status === PublicationStatus.Fresh) {
    return "Fresh";
  }

  if (status === PublicationStatus.Verified) {
    return "Verified";
  }

  if (status === PublicationStatus.Error) {
    return "Error";
  }

  if (status === PublicationStatus.NotFound) {
    return "NotFound";
  }

  if (status === PublicationStatus.RestrictedByAge) {
    return "Restricted";
  }

  if (status === PublicationStatus.HiddenLikesEnabled) {
    return "Restricted";
  }

  if (status === PublicationStatus.StatsUnavailable) {
    return "Restricted";
  }

  return "unknown";
};

export const getTooltipByPublicationStatus = (status: PublicationStatus) => {
  if (status === PublicationStatus.Fresh) {
    return (
      <div>
        <strong>
          <IDHFormattedMessage
            id="ws_publication_fresh_header"
            defaultMessage="Please wait patiently..."
          />
        </strong>
        <br />
        <IDHFormattedMessage
          id="ws_publication_fresh"
          defaultMessage="We are gathering data for this publication. It will be available within a few minutes."
        />
      </div>
    );
  }

  if (status === PublicationStatus.Error) {
    return (
      <IDHFormattedMessage
        id="ws_publication_error"
        defaultMessage={getPublicationStatusNameBasedOnStatus(status)}
      />
    );
  }

  if (status === PublicationStatus.NotFound) {
    return (
      <div>
        <strong>
          <IDHFormattedMessage
            id="ws_publication_not_found_header"
            defaultMessage="Publication was not detected."
          />
        </strong>
        <br />
        <IDHFormattedMessage
          id="ws_publication_not_found"
          defaultMessage="Please check the link's correctness."
        />
      </div>
    );
  }

  if (status === PublicationStatus.RestrictedByAge) {
    return (
      <div>
        <strong>
          <IDHFormattedMessage
            id="ws_publication_restricted_header"
            defaultMessage="Profile data for this account is unavailable."
          />
        </strong>
        <br />
        <IDHFormattedMessage
          id="ws_publication_restricted"
          defaultMessage="The publication's account is restricted."
        />
      </div>
    );
  }

  if (status === PublicationStatus.HiddenLikesEnabled) {
    return (
      <div>
        <strong>
          <IDHFormattedMessage
            id="ws_publication_restricted_likes_views_header"
            defaultMessage="Hidden likes enabled on publication."
          />
        </strong>
        <br />
        <IDHFormattedMessage
          id="ws_publication_restricted_likes_views_description"
          defaultMessage="Likes counts cannot be displayed."
        />
      </div>
    );
  }

  if (status === PublicationStatus.StatsUnavailable) {
    return (
      <div>
        <strong>
          <IDHFormattedMessage
            id="ws_publication_stats_unavailable_header"
            defaultMessage="Statistics unavailable for this publication."
          />
        </strong>
        <br />
        <IDHFormattedMessage
          id="ws_publication_stats_unavailable_description"
          defaultMessage="The creator hasn't enabled stats sharing for this platform."
        />
      </div>
    );
  }

  return (
    <IDHFormattedMessage
      id="ws_publication_status_unknown"
      defaultMessage={getPublicationStatusNameBasedOnStatus(status)}
    />
  );
};
